<template>
  <div class="card-box">
    <a class="pull-right" style="cursor: pointer;" @click="showAll()">Voir toutes les propales</a>
    <h4 class="header-title m-t-0 m-b-20">Propales récentes</h4>

    <ul>
      <li v-for="estimate in relations.estimates" :key="estimate.id">
        <i :class="['text-' + getStatus('estimate', estimate).color, 'fa', getStatus('estimate', estimate).icon]"></i> {{ estimate.number }}
        <span v-if="estimate.amount_total_no_vat !== null">({{ estimate.amount_total_no_vat }} € HT)</span>
        <source-app :name="estimate.source_name" size="tiny"></source-app>
        <div v-if="getStatus('estimate', estimate).text != ''" :class="'text-' + getStatus('estimate', estimate).color">
          {{ getStatus('estimate', estimate).text }}
        </div>
      </li>
      <li v-for="contract in relations.contracts" :key="contract.id">
        <i :class="['text-' + getStatus('contract', contract).color, 'fa', getStatus('contract', contract).icon]"></i> Contrat {{ contract.number }}
        <source-app :name="contract.source_name" size="tiny"></source-app>
        <div v-if="getStatus('contract', contract).text != ''" :class="'text-' + getStatus('contract', contract).color">
          {{ getStatus('contract', contract).text }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import SourceApp from '../../../Entities/SourceApp.vue'

  export default {
    components: {SourceApp},
    name: 'customer-propositions-summary-widget',
    props: ['customer', 'relations'],
    data () {
      return {}
    },
    methods: {
      showAll () {
        this.$emit('show', 'propositions')
      },
      getStatus (type, estimate) {
        if (type === 'estimate') {
          return this.$model.estimate.getStatus(estimate)
        } else {
          return this.$model.contract.getStatus(estimate)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerPropositionsSummaryWidget.vue?cab1acbe